export default __webpack_public_path__ + "static/media/22c6282d-e7aa-406b-89dc-5176916a9c44.a434e0b2.ttf";